import { render, staticRenderFns } from "./UpdateAttributes.vue?vue&type=template&id=6e7620b8"
import script from "./UpdateAttributes.vue?vue&type=script&lang=js"
export * from "./UpdateAttributes.vue?vue&type=script&lang=js"
import style0 from "./UpdateAttributes.vue?vue&type=style&index=0&id=6e7620b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports